// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3_bTI","sendOtp":"AuthorizeToLogin_sendOtp__mSzLr"};